import { NgModule } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';

import { ManagementComponent } from './management.component';
import { ManagementDashboardComponent } from './dashboard.component';
import { CopasComponent } from './copas.component';
import { AuthGuard } from '../../../../src/app/guards/auth.guard';

const managementRoutes: Routes = [
  {
    path: "",
    component: ManagementComponent,
    canActivateChild: [AuthGuard],
    children: [
      { path: './', redirectTo: "", pathMatch: "full" },
      { path: '', component: ManagementDashboardComponent },
      { path: 'copas', component: CopasComponent }
    ]
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(managementRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class ManagementRoutingModule { }
